import { buildTasksApis } from '@rtkwlf/c3-api-tasks';
import { Pod } from '@rtkwlf/c3-lib-pods';

import { fetchWithToken } from '@platform/core/auth';

import { env } from '@packages/utils/env';

export const tasks = buildTasksApis({
  env: {
    pods: Object.values(Pod),
    basePath: env.VITE_TASKS_BASE_PATH,
  },
  config: {
    fetchApi: fetchWithToken,
  },
});
